module.exports = __webpack_public_path__ + "img/goodsA2.dd60d275.png";